import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {DuplicateIcon} from '@primer/octicons-react'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {UnmarkedAsDuplicateEventNode} from './issue-viewer-view-query-types'
import {IssueLink} from './IssueLink'
import {TimelineRow} from './row/TimelineRow'

// RELAY-CLEANUP(UnmarkedAsDuplicateEvent): widens nullable fields so still-Relay parent data is assignable.
// Remove when the timeline pagination fragments and other parents leave Relay.
export type UnmarkedAsDuplicateEventFragment = RelayCompat<
  Pick<
    UnmarkedAsDuplicateEventNode,
    'actor' | 'createdAt' | 'canonical' | 'isCanonicalOfClosedDuplicate' | 'databaseId'
  >
>

type UnmarkedAsDuplicateEventProps = {
  queryRef: UnmarkedAsDuplicateEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  repositoryId: string
  ownerLogin: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
}

export function UnmarkedAsDuplicateEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
  repositoryId,
  ownerLogin,
}: UnmarkedAsDuplicateEventProps): React.ReactElement {
  const {actor, createdAt, canonical, databaseId, isCanonicalOfClosedDuplicate: isCanonicalDuplicate} = queryRef
  const highlighted = String(databaseId) === highlightedEventId

  if (!canonical) return <></>

  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={DuplicateIcon}
    >
      <TimelineRow.Main>
        {isCanonicalDuplicate ? (
          <>
            unmarked{' '}
            <IssueLink inline data={canonical} targetRepositoryId={repositoryId} targetOwnerLogin={ownerLogin} /> as a
            duplicate of this issue{' '}
          </>
        ) : (
          <>
            {LABELS.timeline.unmarkedAsDuplicate}
            <>
              &nbsp;
              <IssueLink data={canonical} targetRepositoryId={repositoryId} targetOwnerLogin={ownerLogin} />{' '}
            </>
          </>
        )}
      </TimelineRow.Main>
    </TimelineRow>
  )
}
